// 基准大小
const baseSize = 16

// 设置 rem
function setRem () {
  let scale = document.documentElement.clientWidth / 1920
  scale = scale >= 0.8125 ? scale : 0.8125
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 1.25) + 'px'
  // document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}

// 初始化
setRem()

window.onresize = function () {
  setRem()
}


// WEBPACK FOOTER //
// ./src/utils/rem.js